/* eslint-disable react-hooks/exhaustive-deps */
import React, { FC, useEffect, useMemo } from 'react';
import { openPasscodeForgotBottomSheet } from '@/modules/auth/components/PasscodeForgotBottomsheet';
import { useAuthenticator } from '@/modules/auth/hooks/Authenticator';
import { useVerifyPasscodeMutation } from '@/modules/auth/hooks/Passcode';
import PasscodeKeypad from '../PasscodeKeypad';

interface IVerifyPasscodeProps {
  onSuccess: () => void;
}

type THandleAuthenticator = undefined | (() => void);

const VerifyPasscode: FC<IVerifyPasscodeProps> = ({ onSuccess }) => {
  const { mutateAsync } = useVerifyPasscodeMutation();
  const { hasAuthenticator, verify: verifyAuthenticator } = useAuthenticator();

  const handleAuthError = (__error?: Error) => {};
  const handlePasscodeError = (__error?: Error) => {};

  const handleAuthenticator: THandleAuthenticator = useMemo(() => {
    if (hasAuthenticator) {
      return () => verifyAuthenticator().then(onSuccess).catch(handleAuthError);
    } else {
      return undefined;
    }
  }, [hasAuthenticator]);

  useEffect(() => {
    handleAuthenticator?.();
  }, [handleAuthenticator]);

  return (
    <PasscodeKeypad
      footerProps={{
        label: 'کد ورود را فراموش کردم!',
        onClick: () => openPasscodeForgotBottomSheet(),
      }}
      title={'کد ورود خود را وارد کنید'}
      validator={async (value) => {
        await mutateAsync(value);
        return true;
      }}
      onAuthenticatorClick={handleAuthenticator}
      onError={(_, error) => handlePasscodeError(error)}
      onSuccess={onSuccess}
    />
  );
};

export default VerifyPasscode;
